// extracted by mini-css-extract-plugin
export default {"stripedRow":"DetailsTable_stripedRow__qw4HM","totalRow":"DetailsTable_totalRow__kTNvc"};